// Aturan penataan ruang dalam (cermin validasi backend interior.py) — dipakai mode Tata agar kesalahan terasa seketika.
import { tapak } from "./interiorRender";

export const ruangDariX = (kat, x) => Object.entries(kat.ruang).find(([, r]) => x >= r.x && x < r.x + r.w)?.[0] || null;

// Kembalikan pesan kesalahan (string) atau null bila `item` sah di antara `lain` (daftar perabot lain) dan kepemilikan `dimiliki`.
export function periksa(kat, item, lain, dimiliki) {
  const def = kat.perabot.find(p => p.key === item.key); if (!def) return "Perabot tidak dikenal";
  const [w, d] = tapak(def, item.rot), sel = [];
  for (let i = 0; i < w; i++) for (let j = 0; j < d; j++) sel.push([item.x + i, item.y + j]);
  if (sel.some(([x, y]) => x < 0 || y < 0 || x >= kat.grid.w || y >= kat.grid.d)) return `${def.nama} keluar dari ruangan`;
  if (new Set(sel.map(([x]) => ruangDariX(kat, x))).size !== 1) return `${def.nama} harus utuh di dalam satu ruang`;
  const wajib = new Set(kat.sel_wajib_kosong.map(([x, y]) => `${x},${y}`));
  if (!def.injak && sel.some(([x, y]) => wajib.has(`${x},${y}`))) return `${def.nama} menutup pintu — geser sedikit`;
  if (!def.injak) for (const o of lain) {
    if (o.id === item.id) continue;
    const od = kat.perabot.find(p => p.key === o.key); if (!od || od.injak) continue;
    const [ow, odp] = tapak(od, o.rot);
    if (sel.some(([x, y]) => x >= o.x && x < o.x + ow && y >= o.y && y < o.y + odp)) return `${def.nama} bertumpuk dengan ${od.nama}`;
  }
  const n = lain.filter(o => o.key === item.key && o.id !== item.id).length + 1;
  const batas = def.kat === "dasar" ? def.jatah : (dimiliki[item.key] || 0);
  if (n > batas) return def.kat === "dasar" ? `Jatah ${def.nama.toLowerCase()} isi dasar: ${batas}` : `Kamu hanya punya ${batas} ${def.nama.toLowerCase()}`;
  return null;
}

// Letakkan tapak (w×d) berpusat di sel yang diketuk, dijepit ke dalam grid
export function pusatkan(kat, def, rot, cx, cy) {
  const [w, d] = tapak(def, rot);
  return { x: Math.max(0, Math.min(kat.grid.w - w, cx - Math.floor((w - 1) / 2))), y: Math.max(0, Math.min(kat.grid.d - d, cy - Math.floor((d - 1) / 2))) };
}
